import { Card, Text, Group, Stack, Title, Divider, Badge } from "@mantine/core";
import { formatMetricDateTime, formatMetricRange, MetricPeriod } from "./timeRange";
// import ReactApexChart from "react-apexcharts";

export interface NewUserStats {
  today: number;
  week: number;
  month: number;
  all: number;
  avg: number;
  current_time?: string;
  timezone?: string;
  periods?: {
    today?: MetricPeriod;
    week?: MetricPeriod;
    month?: MetricPeriod;
    avg?: MetricPeriod;
  };
}

interface Props {
  data: NewUserStats;
}

export function NewUsersCardApex({ data }: Props) {
//   const series = [
//     {
//       name: "New Users",
//       data: [data.today, data.week, data.month],
//     },
//   ];

//   const options: ApexOptions = {
//     chart: {
//       type: "bar",
//       toolbar: { show: false },
//     },
//     plotOptions: {
//       bar: {
//         borderRadius: 6,
//         columnWidth: "45%",
//       },
//     },
//     dataLabels: {
//       enabled: false,
//     },
//     xaxis: {
//       categories: ["Today", "This Week", "This Month"],
//     },
//     yaxis: {
//       labels: {
//         formatter: (value) => Math.round(value).toString(),
//       },
//     },
//     grid: {
//       strokeDashArray: 4,
//     },
//     colors: ["#12b886"], // teal giống Mantine
//     tooltip: {
//       y: {
//         formatter: (val) => `${val} users`,
//       },
//     },
//   };

  return (
    <Card withBorder radius="md" p="lg">
      <Stack spacing="md">
        {/* Header */}
        <Badge color="teal" size="lg" radius="md">
          NEW USERS
        </Badge>
        <Stack spacing={2}>
          <Text size="xs" color="dimmed">Today: {formatMetricRange(data.periods?.today)}</Text>
          <Text size="xs" color="dimmed">This week: {formatMetricRange(data.periods?.week)}</Text>
          <Text size="xs" color="dimmed">This month: {formatMetricRange(data.periods?.month)}</Text>
          <Text size="xs" color="dimmed">Avg based on: {formatMetricRange(data.periods?.avg)}</Text>
          <Text size="xs" color="dimmed">Updated at: {formatMetricDateTime(data.current_time)}</Text>
        </Stack>
        </Stack>
      <Divider my="md" />
      <Stack spacing={12}>

        {/* Stats */}
        <Group position="apart">
          <Text>Today</Text>
          <Title order={4}>{data.today}</Title>
        </Group>

        <Group position="apart">
          <Text>This Week</Text>
          <Title order={4}>{data.week}</Title>
        </Group>

        <Group position="apart">
          <Text>This Month</Text>
          <Title order={4}>{data.month}</Title>
        </Group>

        <Group position="apart">
          <Text>All-Time Users</Text>
          <Title order={4}>{data.all.toLocaleString()}</Title>
        </Group>

        {/* <Divider /> */}

        {/* Chart */}
        {/* <ReactApexChart
          options={options}
          series={series}
          type="bar"
          height={180}
        /> */}

        {/* Avg */}
        <Group position="apart">
          <Text weight={500}>Avg New Users / Day</Text>
          <Title order={3} color="orange">
            {data.avg}
          </Title>
        </Group>
      </Stack>
    </Card>
  );
}
